import React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import CustomSwitch from "../CustomSwitch/";
import AlbumIcon from "@mui/icons-material/Album";
import { grey } from "@mui/material/colors";
import "./style.css";

const PowerFilter = ({
  powerChecked,
  setPowerChecked,
  kudoChecked,
  setKudoChecked,
}) => {
  const handleChangePower = (event) => {
    const { name, checked } = event.target;
    setPowerChecked({ ...powerChecked, [name]: checked });
  };
  const handleChangeKudo = (event) => {
    const { name, checked } = event.target;
    setKudoChecked({ ...kudoChecked, [name]: checked });
  };
  return (
    <FormGroup className='powerWap'>
      <div className='iconTitle'>
        <AlbumIcon sx={{ color: grey[700] }} />
        <h3 className='powerTitle'>パワトレセレクト</h3>
      </div>
      <div className='switch'>
        <FormControlLabel
          control={
            <CustomSwitch
              checked={powerChecked.hev}
              onChange={handleChangePower}
              color='warning'
              name='hev'
              sx={{ m: 1 }}
            />
          }
          label='HEVのみ'
        />
        <FormControlLabel
          control={
            <CustomSwitch
              checked={kudoChecked.awd}
              onChange={handleChangeKudo}
              color='warning'
              name='awd'
              sx={{ m: 1 }}
            />
          }
          label='4WDのみ'
        />
      </div>
    </FormGroup>
  );
};

export default PowerFilter;
